<template>
  <div class="pt-4 d-flex flex-column gap-3">
    <v-skeleton-loader v-if="loading" type="card" height="200px" />
    <v-alert type="error" class="mb-0" v-else-if="error">{{ error }}</v-alert>
    <template v-else>
      <!-- PaymentSummary -->
      <v-card outlined class="pa-2">
        <p class="font-weight-bold mb-2">Detalhes da compra</p>
        <div class="d-flex flex-wrap justify-space-around">
          <div class="text-center px-4">
            <base-copier type="chip" :value="ticket.Payment.id || ''" hide-icon>
              <template v-slot:default="{ copy, icon }">
                <v-chip
                  @click="copy"
                  small
                  label
                  class="text-overline font-weight-medium mt-2"
                >
                  <h6 class=" mb-0">#{{ ticket.Payment.id | shortId }}</h6>
                  <v-icon right x-small>{{ icon }}</v-icon>
                </v-chip>
              </template>
            </base-copier>
            <!-- #{{ ticket.Payment.id | shortId }} -->

            <span class="text-caption">ID do pagamento</span>
          </div>
          <div class="text-center px-4">
            <h6 class="mt-2 mb-0">{{ ticket.Payment._count.Ticket }}</h6>
            <span class="text-caption">Ingressos no carrinho</span>
          </div>
          <div class="text-center px-4">
            <h6 class="mt-2 mb-0">{{ ticket.Payment.amount | currency }}</h6>
            <span class="text-caption">Valor do Pamanento</span>
          </div>
          <div class="text-center px-4">
            <h6 class="mt-2 mb-0">
              {{ ticket.Payment.createdAt | date("DD/MM/YYYY HH:mm") }}
            </h6>
            <span class="text-caption">Data da Compra</span>
          </div>
          <div
            class="text-center px-4"
            v-if="ticket.Payment.status !== 'pending'"
          >
            <h6 class="mt-2 mb-0" v-if="ticket.Payment.payedAt">
              {{ ticket.Payment.payedAt | date("DD/MM/YYYY HH:mm") }}
            </h6>
            <h6 class="mt-2 mb-0" v-else>Não pago</h6>
            <span class="text-caption">Data do Pagamento</span>
          </div>
          <div class="text-center px-4" v-else>
            <h6 class="mt-2 mb-0">
              {{ ticket.Payment.validity | date("DD/MM/YYYY HH:mm") }}
            </h6>
            <span class="text-caption">Validade da compra</span>
          </div>
          <div class="text-center px-4" v-if="ticket.Payment.refundedAt">
            <h6 class="mt-2 mb-0">
              {{ ticket.Payment.refundedAt | date("DD/MM/YYYY HH:mm") }}
            </h6>
            <span class="text-caption">Data do Reembolso</span>
          </div>
          <div class="text-center px-4">
            <h6 class="mt-2 mb-0">
              {{ PAYMENT.paymentMethod[ticket.Payment.paymentMethod]?.text }}
            </h6>
            <span class="text-caption">Meio de Pagamento</span>
          </div>
          <div class="text-center px-4">
            <h6 class="mt-2 mb-0">
              {{ PAYMENT.paymentType[ticket.Payment.paymentType]?.text }}
            </h6>
            <span class="text-caption">Forma de Pagamento</span>
          </div>
        </div>
      </v-card>

      <!-- TicketTransfer -->
      <v-card outlined class="pa-2" v-if="ticket?.TicketTransfer?.length">
        <p class="font-weight-bold mb-2">Transferências</p>
        <v-timeline align-top dense>
          <v-timeline-item large>
            <template v-slot:icon>
              <v-tooltip slot="icon" v-if="!i" top>
                <template v-slot:activator="{ on }">
                  <v-icon size="22" color="white" v-on="on">
                    mdi-account-cash
                  </v-icon>
                </template>
                <span>Comprador original</span>
              </v-tooltip>
            </template>
            <div class="d-flex gap-3 align-center" style="flex: 3">
              <baseAvatar
                :size="30"
                :src="ticket.TicketTransfer[0].from.photo"
                :seed="ticket.TicketTransfer[0].from.id"
              />
              <div>
                <span class="font-weight-bold">
                  {{ ticket.TicketTransfer[0].from.name || "Conta não criada" }}
                </span>
                <small class="d-block">
                  {{ ticket.TicketTransfer[0].from.phone }}
                </small>
              </div>
            </div>
            <v-divider class="mt-4" />
          </v-timeline-item>
          <v-timeline-item
            v-for="(transfer, i) in ticket.TicketTransfer"
            :key="transfer.id"
            class="pb-0"
            :color="
              i + 1 == ticket.TicketTransfer.length ? 'success' : 'primary'
            "
          >
            <template v-slot:icon>
              <span class="white--text font-weight-bold">{{ i + 1 }}</span>
            </template>
            <div class="d-flex gap-3" style="flex: 3">
              <baseAvatar
                class="mt-1"
                :size="30"
                :src="transfer.to.photo"
                :seed="transfer.to.id"
              />
              <div class="flex-grow-1">
                <span class="font-weight-bold">
                  {{ transfer.to.name || "Conta não criada" }}
                </span>
                <small class="d-block lh-1">
                  {{ transfer.to.phone }}
                </small>
              </div>
              <small class="text-overline lh-1">
                {{ transfer.createdAt | date("DD/MM/YY HH:mm") }}
              </small>
            </div>
            <v-divider class="my-4" />
          </v-timeline-item>
        </v-timeline>
      </v-card>

      <!-- RefoundRequest -->
      <v-card outlined class="pa-2" v-if="ticket.RefoundRequest.length">
        <p class="font-weight-bold mb-2">Solicitação de reembolso</p>
        <div
          class="d-flex align-end mb-1 justify-space-between flex-wrap-reverse"
        >
          <h6 class="font-weight-bold mb-0">Motivo</h6>
          <div class="text-end">
            <p class="mb-0 lh-1 font-weight-medium">
              Solicitado em:
              {{ ticket.RefoundRequest[0].createdAt | date("DD/MM/YY HH:mm") }}
            </p>
            <small class="lh-1">
              {{
                [ticket.Payment.createdAt, ticket.RefoundRequest[0].createdAt]
                  | dateDiff
              }}
              após o pagamento
            </small>
          </div>
        </div>
        {{ ticket.RefoundRequest[0].reason }}
        <template v-if="ticket.RefoundRequest[0].closedAt">
          <v-divider class="my-2" />
          <div
            class="d-flex align-end mb-1 justify-space-between flex-wrap-reverse mt-4"
          >
            <h6 class="font-weight-bold mb-0">Resposta</h6>
            <div class="text-end">
              <p class="mb-0 lh-1 font-weight-medium">
                Respondido em:
                {{ ticket.RefoundRequest[0].closedAt | date("DD/MM/YY HH:mm") }}
              </p>
              <small class="lh-1">
                {{
                  [
                    ticket.RefoundRequest[0].createdAt,
                    ticket.RefoundRequest[0].closedAt,
                  ] | dateDiff
                }}
                após a solicitação
              </small>
            </div>
          </div>
          {{ ticket.RefoundRequest[0].answer }}
        </template>
      </v-card>

      <!-- TicketEntry -->
      <v-card outlined class="pa-2">
        <p class="font-weight-bold mb-2">Registros de entrada</p>
        <p v-if="!ticket.TicketEntry.length" class="text-center">
          Nenhum registro de entrada encontrado.
        </p>

        <v-timeline dense v-else>
          <v-timeline-item
            v-for="entry in ticket.TicketEntry"
            :key="entry.id"
            :color="entry.approved ? 'success' : 'error'"
          >
            <template v-slot:icon>
              <v-icon color="white">
                mdi-{{ entry.approved ? "check" : "close" }}
              </v-icon>
            </template>
            <template v-slot:default>
              <div>
                <p class="font-weight-bold text-14">
                  {{ entry.createdAt | date("DD/MM/YYYY HH:mm") }}
                </p>
                <!-- <p class="mb-0">{{ entry.status | status }}</p> -->
              </div>
            </template>
          </v-timeline-item>
        </v-timeline>
      </v-card>

      <div class="d-flex gap-3">
        <!-- <v-btn class="flex-1" small color="success">
          <v-icon x-small left>mdi-send</v-icon>
          Reenviar ingresso
        </v-btn> -->
        <v-btn class="flex-1" @click="transferTicket" small color="info">
          <v-icon x-small left>mdi-account-arrow-right</v-icon>
          Transferir ingresso
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import SUPPORT from "@/services/support";
import payment from "@/utils/payment";
export default {
  name: "TicketDetailsRow",
  data() {
    return {
      loading: true,
      ticket: null,
      error: null,
      opened: false,
      PAYMENT: payment,
    };
  },
  props: {
    party: Object,
  },
  methods: {
    async getTicketDetails() {
      try {
        this.loading = true;
        const { ticket } = await SUPPORT.getTicket(
          this.ticketId,
          this.data.identify
        );
        this.ticket = ticket;
      } catch (e) {
        this.error = e.message || "Erro ao carregar detalhes do ingresso.";
      } finally {
        this.loading = false;
      }
    },
    transferTicket() {
      this.$root.$emit("transfer-ticket", {
        ticket: this.ticket,
        party: this.party,
      });
    },
  },
  watch: {},
  mounted() {
    this.getTicketDetails();
    this.opened = true;
  },
  props: {
    ticketId: String,
    data: Object,
    isOpen: Boolean,
  },
};
</script>

<style></style>
